import * as React from "react";
import { SubState } from "../../../../shared/normalizer";
import { useStoreActions, useStoreState } from "../../../../store/hooks";
import { getItemSelector } from "../../../normalized/selectors/getItemsSelector";
import { BasePermissionWrapper } from "../BasePermissionWrapper";
import { BaseLayout } from "../BaseLayout";
import { BaseNotFound } from "../BaseNotFound";
import { ID } from "../../../../shared/interfaces";

interface IProps<T> {
    match: { params: { id: ID | undefined } };
    subState: SubState;
    editComponent: (item: T | null) => React.ReactNode;
}

export const BaseEditScreen = <T extends { id: ID }>(
    props: React.PropsWithChildren<IProps<T>>
) => {
    const id = props.match.params.id;

    const { getItem } = useStoreActions((actions) => actions.normalize);

    const item: T | null = useStoreState((state) =>
        id ? getItemSelector(state, props.subState, id) : null
    );

    const itemLoading = useStoreState(
        (state) => state.normalize.meta[props.subState].getSingle.loading
    );

    React.useEffect(() => {
        if (id && !item) {
            getItem({ id, subState: props.subState });
        }
    }, []);

    return (
        <BaseLayout>
            <BasePermissionWrapper
                subState={props.subState}
                permission="change"
                showMessage={true}
                loading={itemLoading}
            >
                {item || !id ? props.editComponent(item) : <BaseNotFound />}
            </BasePermissionWrapper>
        </BaseLayout>
    );
};
